module.exports = __webpack_public_path__ + "static/media/location.33f1229e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/location.svg
// module id = 107
// module chunks = 0